# ──────────────────────────────────────────────────────────────────────────
# राजधर्मानुशासन योग – धनुर्वेद अभ्यास
# Content file: shareable sections and statements for the program overview.
#
# How to make content shareable:
#   • Set  shareable: true  on a section  → the heading gets a hover 🔗 icon.
#   • Set  shareable: true  on a statement → the paragraph gets an inline 🔗 icon.
#     (statement MUST also have a unique  id:  when shareable: true)
#
# Types for statements:  paragraph (default) | quote | note
# ──────────────────────────────────────────────────────────────────────────

title: "राजधर्मानुशासन योग – धनुर्वेद अभ्यास"
description: "हिमाचल प्रदेश के धर्मशाला में अर्जुन की परम्परा में धनुर्विद्या सीखें।"

sections:
  - id: darshan
    heading: "कार्यक्रम दर्शन"
    shareable: true
    statements:
      - id: dhanurveda-not-weapon
        text: |-
          आयुर्वेद, धनुर्वेद, गान्धर्ववेद और अर्थशास्त्र — ये चार उपवेद माने गये हैं। 
      
          धनुर्वेदके चार भेद हैं — मुक्त, अमुक्त, मुक्तामुक्त तथा मन्त्रमुक्त। छोड़े जानेवाले बाण आदिको ‘मुक्त’ कहते हैं। जिन्हें हाथमें लेकर प्रहार किया जाय, उन खड्‌ग आदिको ‘अमुक्त’ कहते हैं। जिस अस्त्रको चलाने और समेटनेकी कला मालूम हो, वह अस्त्र ‘मुक्तामुक्त’ कहलाता है। जिसे मन्त्र पढ़कर चला तो दिया जाय किंतु उसके उपसंहारकी विधि मालूम न हो, वह अस्त्र ‘मन्त्रमुक्त’ कहा गया है, शस्त्र, अस्त्र, प्रत्यस्त्र और परमास्त्र—ये भी धनुर्वेदके चार भेद हैं। 
          
          इसी प्रकार आदान, संधान, विमोक्ष और संहार—इन चार क्रियाओंके भेदसे भी धनुर्वेदके चार भेद होते हैं। - महाभारत में  गीताप्रेस गोरखपुर के अनुसार टिप्पणी। 
          
        shareable: true

      - id: tradition-age
        text: "यह परम्परा ५,००० वर्ष से अधिक पुरानी है। महाभारत-काल में धनुर्वेद, चारों उपवेदों में से एक था।"
        shareable: true

      - text: "इस कार्यक्रम में पारम्परिक लकड़ी के धनुष और बाँस के बाणों का उपयोग किया जाता है।"

  - id: lakshy
    heading: "कार्यक्रम के लक्ष्य"
    shareable: true
    statements:
      - id: goal-focus
        text: "मन की एकाग्रता और ध्यान-केन्द्रण की क्षमता विकसित करना।"
        shareable: true

      - id: goal-culture
        text: "भारतीय सांस्कृतिक विरासत को पुनः जीवन्त करना — केवल मनोरंजन नहीं, गहरी साधना।"
        shareable: true

      - text: "प्रत्येक अभ्यासी को सुरक्षा प्रशिक्षण अनिवार्य रूप से दिया जाता है।"
        type: note

  - id: safety
    heading: "सुरक्षा एवं कानूनी स्थिति"
    shareable: true
    statements:
      - id: arms-act-note
        text: "पारम्परिक लकड़ी के धनुष और बाँस के बाण भारतीय शस्त्र अधिनियम, १९५९ के अन्तर्गत 'शस्त्र' की श्रेणी में नहीं आते।"
        shareable: true
        type: note

      - id: supervised-only
        text: "सभी अभ्यास सत्र प्रशिक्षित आचार्य की प्रत्यक्ष देख-रेख में ही आयोजित होते हैं।"
        shareable: true

  - id: location
    heading: "स्थान – धर्मशाला, हिमाचल प्रदेश"
    shareable: true
    statements:
      - id: location-detail
        text: "धर्मशाला की हिमालयी पर्वत-श्रृंखला के मध्य, प्राकृतिक परिवेश में यह कार्यक्रम संचालित होता है।"
        shareable: true

      - text: "प्रतिभागियों के लिए आवास की अग्रिम बुकिंग की सुविधा उपलब्ध है।"

  - id: prerequesites
    heading: "आवश्यकताएँ"
    items:
      - "आयु: १६ वर्ष या उससे अधिक"
      - "चिकित्सीय स्वास्थ्य घोषणापत्र अनिवार्य"
      - "कोई पूर्व धनुर्विद्या अनुभव आवश्यक नहीं"
      - "अभिभावक की लिखित सहमति (अवयस्कों के लिए)"
